import React from 'react'
import { ComboBox, MultiSelect } from '@progress/kendo-react-dropdowns'
import { filterBy } from "@progress/kendo-data-query";
import { accentUtils, t ,from} from '../../services/HelperService'
import { AccentLabel } from '../AccentLabel';


export class AccentComboUnbound extends React.Component {

    constructor(props) {
        super(props);

        this.ctrl = React.createRef();


        

        var valueField = this.props.valueField;
        var val = this.props.defaultValue;
        var value = from(this.props.data).where(v => v[valueField] === val).firstOrDefault();


        if (this.props.allowCustom) {

            if (!accentUtils.isEmpty(val) && accentUtils.isNull(value)) {
                value = {
                    [this.props.valueField]: new Date().getTime(),
                    [this.props.displayField]: val
                };
            }

        }


        if (accentUtils.isNull(value) && this.props.defaultSingle) {
            if (this.props.data.length == 1) {
                value = this.props.data[0];
            }
        }

        this.state = {
            value: value,
            show: undefined,
            filter: null,
            // Bumped to remount the ComboBox when typed text that matches nothing
            // must give way to the committed value again (Kendo keeps the text).
            resetKey: 0
        };

        // Accessible name: Kendo's ComboBox (7.x) takes ariaLabelledBy only, so an
        // ariaLabel prop renders as a visually-hidden span the input points at.
        this.labelID = `accentCombo_${Math.random().toString(36).slice(2, 10)}`;

        this.onChange = this.onChange.bind(this);
        this.onFocus = this.onFocus.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.onClose = this.onClose.bind(this);
        this.onOpen = this.onOpen.bind(this);
        this.getValue = this.getValue.bind(this);
        this.onFilterChange = this.onFilterChange.bind(this);
    }

    getValue() {
        return this.state.value;
    }

    onOpen(e) {

        if (this.props.openOnFocus) {
            this.setState({ show: true });
        }

    }

    onClose(e) {
        if (this.props.openOnFocus) {
            this.setState({ show: false });
        }
    }

    onFocus(e) {
        if (this.props.openOnFocus) {
            this.setState({ show: true });
        }
    }

    // Typed text is committed on blur when it names an item exactly (case- and
    // whitespace-insensitive) — Kendo leaves "5/16" on show without selecting it,
    // and a measurement control then displayed 13 5/16 while the committed width
    // stayed 13 3/16. Text that names nothing (and no custom values allowed) is
    // dropped: the ComboBox remounts so the committed value shows again.
    onBlur(e) {
        const typed = this.state.filter?.value;
        if (!accentUtils.isEmpty(typed) && typeof typed === "string") {
            const wanted = typed.trim().toLowerCase();
            // The caller may widen what counts as "names this item" — the fraction
            // picker lets "1/4" land on "4/16 (1/4)".
            const matches = typeof this.props.matchTypedText === "function"
                ? x => this.props.matchTypedText(typed.trim(), x)
                : x => `${x[this.props.displayField] ?? ""}`.trim().toLowerCase() === wanted;
            const match = from(this.props.data).firstOrDefault(x => `${x[this.props.displayField] ?? ""}`.trim().toLowerCase() === wanted)
                ?? from(this.props.data).firstOrDefault(matches);
            if (!accentUtils.isNull(match)) {
                if (match !== this.state.value) {
                    this.onChange({ target: { value: match } });
                } else {
                    this.setState({ filter: null });
                }
            } else if (!this.props.allowCustom) {
                this.setState(prev => ({ filter: null, resetKey: prev.resetKey + 1 }));
            }
        }

        if (!accentUtils.isNull(this.props.onBlur)) {
            this.props.onBlur(e);
        }
    }

    onChange(e) {

        if (!accentUtils.isNull(this.props.onChange)) {
            this.props.onChange(accentUtils.isNull(e.target.value) ? null : e.target.value[this.props.valueField]);
        }

        if (!accentUtils.isNull(this.props.onDisplayChange)) {
            this.props.onDisplayChange(accentUtils.isNull(e.target.value) ? null : e.target.value[this.props.displayField]);
        }


        this.setState({ value: e.target.value, filter: null });
    }

    onFilterChange(e) {
        this.setState({ filter : e.filter})
    }


    render() {


        const isNotValue = this.props.required && (accentUtils.isNull(this.state.value) || (!accentUtils.isNull(this.props.emptyValue) && this.state.value[this.props.valueField] === this.props.emptyValue));
        const isValid = !isNotValue;

        var className = isValid ? "accentComboUnbound" : "accentComboUnbound invalid";


        const itemRender = accentUtils.isNull(this.props.itemRender) ? undefined : (li, itemProps) => React.cloneElement(li, li.props, this.props.itemRender(li, itemProps));

        const data = this.props.data;

        if (this.props.allowCustom) {

            const currVal = this.state.value;


            if (!accentUtils.isNull(currVal)) {

                var currItem = from(data).firstOrDefault(x => x === currVal);


                if (accentUtils.isNull(currItem)) {

                    data.push(currVal);
                }
            }
        }

        const filteredData = accentUtils.isNull(this.state.filter) ? data : filterBy(data.slice(), this.state.filter);

        // The accessible name: the visible AccentLabel when there is one, else the
        // ariaLabel prop rendered visually hidden; neither leaves an unnamed combobox.
        const hasLabel = !accentUtils.isEmpty(this.props.label);
        const hasAriaLabel = !accentUtils.isEmpty(this.props.ariaLabel);
        const labelledBy = hasLabel || hasAriaLabel ? this.labelID : this.props.ariaLabelledBy;

        const combo = <ComboBox
            key={this.state.resetKey}
            className={`${className} ${this.props.className}`}
            data={filteredData}
            value={this.state.value}
            onChange={this.onChange}
            textField={this.props.displayField}
            dataItemKey={this.props.valueField}
            disabled={this.props.disabled}
            itemRender={itemRender}
            opened={this.state.show}
            filterable
            //loading={this.props.loading}
            onFilterChange={this.onFilterChange}
            style={{ width: "100%" }}
            onFocus={this.onFocus}
            onBlur={this.onBlur}
            onClose={this.onClose}
            onOpen={this.onOpen}
            placeholder={this.props.placeHolder}
            clearButton={!this.props.hideClear}
            popupSettings={{ className: this.props.popupClassName }}
            allowCustom={this.props.allowCustom}
            valueRender={this.props.valueRender}
            ariaLabelledBy={labelledBy}
        />

        if (!hasLabel) {
            return <div data-tagname={this.props.dataTagName}>
                {hasAriaLabel && <span id={this.labelID} className="visually-hidden">{this.props.ariaLabel}</span>}
                {combo}
            </div>;
        }

        return <AccentLabel text={this.props.label} labelID={this.labelID}>
            <div data-tagname={this.props.dataTagName}>{combo}</div>
        </AccentLabel>;

    }

}



export class AccentMultiComboUnbound extends React.Component {

    constructor(props) {
        super(props);

        this.ctrl = React.createRef();


        var valueField = this.props.valueField;
        var val = this.props.defaultValue;
        var value = accentUtils.isNull(val) ? [] : from(this.props.data).where(v => val.includes(v[valueField])).toArray();

        if (accentUtils.isNull(value) && this.props.defaultSingle) {
            if (this.props.data.length == 1) {
                value = this.props.data[0];
            }
        }

        this.state = { value: value, filter: null, isOpen: false, hasPendingChange: false };

        this.onChange = this.onChange.bind(this);
        this.onFilterChange = this.onFilterChange.bind(this);
        this.onOpen = this.onOpen.bind(this);
        this.onClose = this.onClose.bind(this);
        this.emitValueChange = this.emitValueChange.bind(this);
        
    }

    emitValueChange(valueObjects) {
        if (!accentUtils.isNull(this.props.onChange)) {
            this.props.onChange(accentUtils.isEmpty(valueObjects) ? [] : valueObjects.map(v => v[this.props.valueField]));
        }
    }

    onChange(e) {
        const nextValue = accentUtils.isNull(e.target.value) ? [] : e.target.value;
        const commitOnClose = !!this.props.commitOnClose;

        if (!commitOnClose || !this.state.isOpen) {
            this.emitValueChange(nextValue);
            this.setState({ value: nextValue, filter: null, hasPendingChange: false });
            return;
        }

        this.setState({ value: nextValue, filter: null, hasPendingChange: true });
    }

    onFilterChange(e) {
        this.setState({ filter : e.filter})
    }

    onOpen() {
        this.setState({ isOpen: true });
    }

    onClose() {
        const shouldCommit = !!this.props.commitOnClose && this.state.hasPendingChange;
        const currentValue = this.state.value;

        this.setState({ isOpen: false, hasPendingChange: false });

        if (shouldCommit) {
            this.emitValueChange(currentValue);
        }
    }


    render() {

        var isValid = !this.props.required || (!accentUtils.isNull(this.state.value) && this.state.value.length > 0);

        var className = isValid ? "accentComboUnbound" : "accentComboUnbound invalid";
        const checkedListMode = !!this.props.checkedListMode;
        const keepOpenOnSelect = checkedListMode || !!this.props.keepOpenOnSelect;


        const selectedIDs = new Set((this.state.value || []).map(v => v[this.props.valueField]));
        const baseItemRender = accentUtils.isNull(this.props.itemRender) ? undefined : (li, itemProps) => React.cloneElement(li, li.props, this.props.itemRender(li, itemProps));
        const showSelectedCheckIcon = !!this.props.showSelectedCheckIcon;
        const itemRender = (!showSelectedCheckIcon && accentUtils.isNull(baseItemRender))
            ? undefined
            : (li, itemProps) => {
                const renderedLi = accentUtils.isNull(baseItemRender) ? li : baseItemRender(li, itemProps);

                if (!showSelectedCheckIcon) {
                    return renderedLi;
                }

                const itemID = itemProps?.dataItem?.[this.props.valueField];
                const isSelected = selectedIDs.has(itemID);

                return React.cloneElement(
                    renderedLi,
                    renderedLi.props,
                    <span className="d-flex align-items-center" style={{ gap: "8px" }}>
                        <span style={{ width: "14px", display: "inline-block", textAlign: "center" }}>{isSelected ? "✓" : ""}</span>
                        <span>{renderedLi.props.children}</span>
                    </span>
                );
            };

        const data = this.props.data;
        const filteredData = accentUtils.isNull(this.state.filter) ? data : filterBy(data.slice(), this.state.filter);


        return <MultiSelect
            placeholder={this.props.placeHolder}
            className={`${className} ${this.props.className}`}
            data={filteredData}
            value={this.state.value}
            onChange={this.onChange}
            textField={this.props.displayField}
            dataItemKey={this.props.valueField}
            disabled={this.props.disabled}
            itemRender={itemRender}
            label={t(this.props.label)}
            filterable
            autoClose={!keepOpenOnSelect}
            onFilterChange={this.onFilterChange}
            onOpen={this.onOpen}
            onClose={this.onClose}
            style={{ width: "100%" }}
        />

    }

}
